<div class="mb-xl-0 text-center text-md-start shadow-register p-3 bg-white corner-radius responsive-noShadow">
    <div>
      <div class="card-body p-6">
        <div class="mb-5 hidden-sm" style="padding: 0px 20px 0px 20px;">
          <label class="mb-2 lh-1 fw-bold h5 business-header">Log in to Swiftchat
            Business Manager</label>
          <label class="business-sub-header">Enter your login credentials to easily
            manage your business</label>
        </div>
        <div class="row">
          <div class="jumbotron">
            <div class="container">
                <app-alert></app-alert>
            </div>
          </div>
        </div>
        <form [formGroup]="registerForm"  (ngSubmit)="onSubmit()" class="x-axis-no-padding" style="padding: 0px 20px 0px 20px;">
          <mat-form-field class="form-element col-12 col-md-12 mat-floating-label" style="margin-bottom:20px;">
            <input  class="input-style" matInput placeholder="Email" formControlName="email" />
            <mat-error *ngIf="
                                  !registerForm.controls['email'].valid &&
                                  registerForm.controls['email'].touched
                                ">
                                {{ getErrorEmail() }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-element col-12 col-md-12 mat-floating-label" style="padding-bottom:10%">
            <input  class="input-style" matInput placeholder="Password" type="password" formControlName="password" style="width: 65%;"/>

            <a class="forgot-link" (click)="open()">Forgot Password?</a>
            <mat-error *ngIf="
                                    !registerForm.controls['password'].valid &&
                                    registerForm.controls['password'].touched
                                  ">
              Please enter password
            </mat-error>
          </mat-form-field>
          
          <!-- <div class="mb-3 py-3">
            <div class="form-check text-start">
                <input class="form-check-input" type="checkbox" formControlName="rememberMe" id="flexRememberMe">
                <label class="form-check-label mat-floating-label" for="flexRememberMe">
                    Remember Me
                </label>
              </div>
          </div> -->
          <div class="d-flex justify-content-center mb-3">
            <button type="submit" class="btn add btn-primary" style="width: 274px;border-radius: 80px;">Log in</button>
          </div>
        </form>
        <div class="d-flex justify-content-center x-axis-no-padding" style="padding: 0px 20px 0px 20px;font-size: 14px;">
        <p>New to<b> Business Manager</b>?
            <a routerLink="/register" class="text-inherit fw-semi-bold" style="text-decoration:none ;">Register
            Now</a>
        </p>
        </div>
      </div>
    </div>
  </div>